module.exports = __webpack_public_path__ + "media/images/flags/1x1/svk-5317ef1a429e9442473d2b48a54c183a.svg";